// extracted by mini-css-extract-plugin
module.exports = {"photogallery":"photo-gallery-module--photogallery--HOd0F"};